import { render, staticRenderFns } from "./q-btn.vue?vue&type=template&id=724fecba&scoped=true&"
import script from "./q-btn.vue?vue&type=script&lang=js&"
export * from "./q-btn.vue?vue&type=script&lang=js&"
import style0 from "./q-btn.vue?vue&type=style&index=0&id=724fecba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724fecba",
  null
  
)

export default component.exports